import { SideBar } from "./SideBar/SideBar";

import './PageLayout.scss';

export const PageLayout = (props: any) => {
    
    return (
        <>
            <SideBar />
            {props.children}
        </>
    );
};